import React from "react";
import { MDBAccordion, MDBAccordionItem, MDBContainer } from "mdb-react-ui-kit";
import { MDBTypography } from 'mdb-react-ui-kit';
import "../App.css";
import Seo from "../components/Seo";
export default function App() {
  const faqs = [
    {
      q: "How can I contact customer service?",
      a: "Email sales@ctlaus.com or call +61 8 0000 0000, Mon–Fri 8:30–5:00 AWST."
    },
    {
      q: "What safety standards do your products meet?",
      a: "Products list applicable AS/NZS, ISO or IEC standards on their pages and datasheets."
    },
    {
      q: "Do you offer international shipping?",
      a: "Yes—contact us for freight quotes. We dispatch Australia-wide and export on request."
    },
    {
      q: "What is your return policy?",
      a: "Eligible items can be returned within 30 days in original condition. See Returns & Refunds for details."
    }
  ];

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(f => ({
      "@type": "Question",
      "name": f.q,
      "acceptedAnswer": { "@type": "Answer", "text": f.a }
    }))
  };

  return (
    <>
      <Seo
        title="Frequently Asked Questions"
        description="Answers on orders, delivery, standards, international shipping and returns."
        canonicalPath="/faq"
        schema={schema}
      />
      <h1>Frequently Asked Questions</h1>
      {/* your accordion UI here */}


      <MDBContainer className="mt-5" style={{ maxWidth: '1000px' }}>
        <MDBAccordion alwaysOpen initialActive={1}>
          <MDBTypography tag='h1' className="heading">FA<i className="text-muted" color="blue">Q</i> </MDBTypography><br />
          <MDBAccordionItem collapseId={1} headerTitle="HOW DO I MAKE A PURCHASE ON CTL.COM.AU?.">
            It is shown
            by default, until the collapse plugin adds the appropriate classes
            that we use to style each element. These classes control the overall
            appearance, as well as the showing and hiding via CSS transitions. You
            can modify any of this with custom CSS or overriding our default
            variables. It's also worth noting that just about any HTML can go
            within the <code>.accordion-body</code>, though the transition does
            limit overflow.
          </MDBAccordionItem>
          <MDBAccordionItem collapseId={2} headerTitle="HOW DO I PAY FOR MY ORDER?">
            It is
            hidden by default, until the collapse plugin adds the appropriate
            classes that we use to style each element. These classes control the
            overall appearance, as well as the showing and hiding via CSS
            transitions. You can modify any of this with custom CSS or overriding
            our default variables. It's also worth noting that just about any HTML
            can go within the <code>.accordion-body</code>, though the transition
            does limit overflow.
          </MDBAccordionItem>
          <MDBAccordionItem collapseId={3} headerTitle="WHAT PAYMENT TYPES DO YOU ACCEPT?">
            <strong>This is the third item's accordion body.</strong> It is hidden
            by default, until the collapse plugin adds the appropriate classes
            that we use to style each element. These classes control the overall
            appearance, as well as the showing and hiding via CSS transitions. You
            can modify any of this with custom CSS or overriding our default
            variables. It's also worth noting that just about any HTML can go
            within the <code>.accordion-body</code>, though the transition does
            limit overflow.
          </MDBAccordionItem>
          <MDBAccordionItem collapseId={3} headerTitle="DO I NEED TO HAVE AN ACCOUNT BEFORE I PLACE AN ORDER?">
            <strong>This is the third item's accordion body.</strong> It is hidden
            by default, until the collapse plugin adds the appropriate classes
            that we use to style each element. These classes control the overall
            appearance, as well as the showing and hiding via CSS transitions. You
            can modify any of this with custom CSS or overriding our default
            variables. It's also worth noting that just about any HTML can go
            within the <code>.accordion-body</code>, though the transition does
            limit overflow.
          </MDBAccordionItem>
          <MDBAccordionItem collapseId={3} headerTitle="WHERE DO YOU DELIVER TO?">
            <strong>This is the third item's accordion body.</strong> It is hidden
            by default, until the collapse plugin adds the appropriate classes
            that we use to style each element. These classes control the overall
            appearance, as well as the showing and hiding via CSS transitions. You
            can modify any of this with custom CSS or overriding our default
            variables. It's also worth noting that just about any HTML can go
            within the <code>.accordion-body</code>, though the transition does
            limit overflow.
          </MDBAccordionItem>
          <MDBAccordionItem collapseId={3} headerTitle="HOW LONG DOES DELIVERY TAKE?">
            <strong>This is the third item's accordion body.</strong> It is hidden
            by default, until the collapse plugin adds the appropriate classes
            that we use to style each element. These classes control the overall
            appearance, as well as the showing and hiding via CSS transitions. You
            can modify any of this with custom CSS or overriding our default
            variables. It's also worth noting that just about any HTML can go
            within the <code>.accordion-body</code>, though the transition does
            limit overflow.
          </MDBAccordionItem>
          <MDBAccordionItem collapseId={3} headerTitle="DO YOU DELIVER INTERNATIONALLY?">
            <strong>This is the third item's accordion body.</strong> It is hidden
            by default, until the collapse plugin adds the appropriate classes
            that we use to style each element. These classes control the overall
            appearance, as well as the showing and hiding via CSS transitions. You
            can modify any of this with custom CSS or overriding our default
            variables. It's also worth noting that just about any HTML can go
            within the <code>.accordion-body</code>, though the transition does
            limit overflow.
          </MDBAccordionItem>
          <MDBAccordionItem collapseId={3} headerTitle="HOW MUCH IS DELIVERY?">
            <strong>This is the third item's accordion body.</strong> It is hidden
            by default, until the collapse plugin adds the appropriate classes
            that we use to style each element. These classes control the overall
            appearance, as well as the showing and hiding via CSS transitions. You
            can modify any of this with custom CSS or overriding our default
            variables. It's also worth noting that just about any HTML can go
            within the <code>.accordion-body</code>, though the transition does
            limit overflow.
          </MDBAccordionItem>
          <MDBAccordionItem collapseId={3} headerTitle="HOW MUCH IS DELIVERY FOR A HEAVY, BULKY OR OVER-SIZED ORDER?">
            <strong>This is the third item's accordion body.</strong> It is hidden
            by default, until the collapse plugin adds the appropriate classes
            that we use to style each element. These classes control the overall
            appearance, as well as the showing and hiding via CSS transitions. You
            can modify any of this with custom CSS or overriding our default
            variables. It's also worth noting that just about any HTML can go
            within the <code>.accordion-body</code>, though the transition does
            limit overflow.
          </MDBAccordionItem>
          <MDBAccordionItem collapseId={3} headerTitle="CAN YOU DELIVER TO AN ADDRESS THAT IS DIFFERENT TO MY BILLING ADDRESS?">
            <strong>This is the third item's accordion body.</strong> It is hidden
            by default, until the collapse plugin adds the appropriate classes
            that we use to style each element. These classes control the overall
            appearance, as well as the showing and hiding via CSS transitions. You
            can modify any of this with custom CSS or overriding our default
            variables. It's also worth noting that just about any HTML can go
            within the <code>.accordion-body</code>, though the transition does
            limit overflow.
          </MDBAccordionItem>
          <MDBAccordionItem collapseId={3} headerTitle="WHAT IS CLICK & COLLECT?">
            <strong>This is the third item's accordion body.</strong> It is hidden
            by default, until the collapse plugin adds the appropriate classes
            that we use to style each element. These classes control the overall
            appearance, as well as the showing and hiding via CSS transitions. You
            can modify any of this with custom CSS or overriding our default
            variables. It's also worth noting that just about any HTML can go
            within the <code>.accordion-body</code>, though the transition does
            limit overflow.
          </MDBAccordionItem>

          <MDBAccordionItem collapseId={3} headerTitle="HOW DO I MAKE A RETURN?">
            <strong>This is the third item's accordion body.</strong> It is hidden
            by default, until the collapse plugin adds the appropriate classes
            that we use to style each element. These classes control the overall
            appearance, as well as the showing and hiding via CSS transitions. You
            can modify any of this with custom CSS or overriding our default
            variables. It's also worth noting that just about any HTML can go
            within the <code>.accordion-body</code>, though the transition does
            limit overflow.
          </MDBAccordionItem>
          <MDBAccordionItem collapseId={3} headerTitle="I HAVE FORGOTTEN THE PASSWORD TO MY HOME & TRADE ACCOUNT.">
            <strong>This is the third item's accordion body.</strong> It is hidden
            by default, until the collapse plugin adds the appropriate classes
            that we use to style each element. These classes control the overall
            appearance, as well as the showing and hiding via CSS transitions. You
            can modify any of this with custom CSS or overriding our default
            variables. It's also worth noting that just about any HTML can go
            within the <code>.accordion-body</code>, though the transition does
            limit overflow.
          </MDBAccordionItem>
          <MDBAccordionItem collapseId={3} headerTitle="I HAVE RECEIVED FAULTY OR DAMAGED ITEMS, WHAT DO I DO?">
            <strong>This is the third item's accordion body.</strong> It is hidden
            by default, until the collapse plugin adds the appropriate classes
            that we use to style each element. These classes control the overall
            appearance, as well as the showing and hiding via CSS transitions. You
            can modify any of this with custom CSS or overriding our default
            variables. It's also worth noting that just about any HTML can go
            within the <code>.accordion-body</code>, though the transition does
            limit overflow.
          </MDBAccordionItem>
          <MDBAccordionItem collapseId={3} headerTitle="HOW DO I MODIFY OR CANCEL MY ONLINE ORDER?">
            <strong>This is the third item's accordion body.</strong> It is hidden
            by default, until the collapse plugin adds the appropriate classes
            that we use to style each element. These classes control the overall
            appearance, as well as the showing and hiding via CSS transitions. You
            can modify any of this with custom CSS or overriding our default
            variables. It's also worth noting that just about any HTML can go
            within the <code>.accordion-body</code>, though the transition does
            limit overflow.
          </MDBAccordionItem>
        </MDBAccordion>
      </MDBContainer>
    </>
  );
}